import {takeEvery} from 'redux-saga/effects'

import {
  CREATE_INQUIRY,
  DELETE_INQUIRIES,
  DELETE_INQUIRY,
  GET_INQUIRIES,
  GET_INQUIRY,
  GET_INQUIRY_TYPES,
  SEND_INQUIRY_MESSAGE,
  UPDATE_INQUIRY,
} from '../../Actions/Inquiry/ActionTypes/ApiActionType'
import fetchData from '../SagaHelper'

function* dataSaga() {
  yield takeEvery(GET_INQUIRIES, fetchData)
  yield takeEvery(GET_INQUIRY, fetchData)
  yield takeEvery(UPDATE_INQUIRY, fetchData)
  yield takeEvery(SEND_INQUIRY_MESSAGE, fetchData)
  yield takeEvery(CREATE_INQUIRY, fetchData)
  yield takeEvery(GET_INQUIRY_TYPES, fetchData)

  yield takeEvery(DELETE_INQUIRY, fetchData)
  yield takeEvery(DELETE_INQUIRIES, fetchData)
}

export default dataSaga
